import { usePlayerActions } from "@utils/player/core/usePlayer";
import LText from "@components/LText";
import Button from "../common/Button";
import LIcon from "@components/LIcon";
import {
  AccessDetailsDismiss,
  MusicAccess,
} from "@components/Accesses/AccessDetails/types";

const Play = ({
  song,
  dismiss,
}: {
  song?: MusicAccess["songs"][number];
  dismiss: AccessDetailsDismiss;
}) => {
  const playerActions = usePlayerActions();

  const playFromCollection = playerActions.playFromCollection;

  if (!song) return null;

  return (
    <Button.Button
      onPress={() => {
        if (!song.albums?.[0]) return;
        playFromCollection({
          songId: song.id,
          collectionType: "album",
          collectionId: song.albums[0].id,
          collectionName: song.albums[0].title,
        });
        dismiss({ pathname: "/(app)/(tabs)/home" });
      }}
      sentryEventName="AccessDetail.Play"
    >
      <LIcon colors={{ color: "black" }} name="play" size={16} />
      <LText variant="Caption/C1/Medium" color="black">
        Play
      </LText>
    </Button.Button>
  );
};

export default Play;
